import React, { useState, useEffect } from 'react';
import { Modal, toast } from '@getpingback/realeza';
import { Button, TextField } from '@material-ui/core';
import { createModule, updateModule } from '../../../services/education';

const NewModuleModal = ({ isOpen, onClose, courseId, onCreated, moduleData }) => {
  const [moduleName, setModuleName] = useState('');

  useEffect(() => {
    if (moduleData) {
      setModuleName(moduleData.name);
    }
  }, [moduleData]);

  const handleClose = () => {
    onClose();
    setModuleName('');
  };

  const handleCreateModule = async () => {
    try {
      await createModule(courseId, moduleName);
      handleClose();
      onCreated();

      toast.success('Module created successfully');
    } catch (error) {
      console.log(error);

      toast.error(`Failed to create module: ${error?.response?.data?.error?.message}`);
    }
  };

  const handleEditModule = async () => {
    try {
      await updateModule(moduleData?.id, moduleName);
      handleClose();
      onCreated();
      toast.success('Module updated successfully');
    } catch (error) {
      console.log(error);

      toast.error(`Failed to update module: ${error?.response?.data?.error?.message}`);
    }
  };

  return (
    <Modal onClose={handleClose} isOpen={isOpen} className="education__course__new-module">
      <h2>{moduleData ? 'Edit Module' : 'New Module'}</h2>
      <form className="education__course__new-module__form">
        <TextField
          label="Module Name"
          type="text"
          placeholder="Enter module name"
          value={moduleName}
          onChange={e => setModuleName(e.target.value)}
        />

        <Button variant="contained" color="primary" onClick={moduleData ? handleEditModule : handleCreateModule}>
          {moduleData ? 'Edit Module' : 'Create Module'}
        </Button>
      </form>
    </Modal>
  );
};

export default NewModuleModal;
